module.exports = __webpack_public_path__ + "static/sec1-0f498f9a1be080b43524606c7e232ccc.png";